import { MENU_MODULE_NAME_MAP, includeFields } from "../constants";
import SnackbarUtils from "../components/NotistackPlus";
import isEqual from "lodash/isEqual";

export function translateStatus(status: any) {
  if (status === "") {
    return "";
  } else {
    switch (Number(status)) {
      case 0:
        return "In-Draft";
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      case 3:
        return "Archived";
      default:
        return "In-Draft";
    }
  }
}

export const toArray = (value: any) => {
  return Array.isArray(value) ? value : [value];
};

export const replaceParams = (url: string, context: Record<string, any>) => {
  if (!url) return "";
  for (const key in context) {
    if (context.hasOwnProperty(key)) {
      const value = context[key];
      const pattern = "${" + key + "}";
      url = url.replace(pattern, value);
    }
  }
  return url;
};

export function mappingAdminType(type: string) {
  switch (type) {
    case "user":
      return 0;
    case "role":
      return 1;
    case "group":
      return 2;
    case "acl":
      return 3;
    default:
      return 0;
  }
}

export function uniqueArray(arr: any[], propName?: string) {
  const res = new Map();
  if (propName) {
    return arr.filter((a) => !res.has(a[propName]) && res.set(a[propName], 1));
  } else {
    return arr.filter((a) => !res.has(a) && res.set(a, 1));
  }
}

export function titleCase(str: string) {
  let newStr = str.split(" ");
  for (let i = 0; i < newStr.length; i++) {
    newStr[i] =
      newStr[i].slice(0, 1).toUpperCase() + newStr[i].slice(1).toLowerCase();
  }
  return newStr.join(" ");
}

export function firstWordCase(parameter: string) {
  return parameter.slice(0, 1).toUpperCase() + parameter.slice(1).toLowerCase();
}

export function logoutFunction() {
  localStorage.clear();
}

const isObject = (target: any) => {
  return (
    (typeof target === "object" || typeof target === "function") &&
    target !== null
  );
};

export function deepClone(target: any, map = new WeakMap()) {
  if (map.get(target)) {
    return target;
  }
  if (isObject(target)) {
    map.set(target, true);
    const cloneTarget: any = Array.isArray(target) ? [] : {};
    for (let prop in target) {
      if (target.hasOwnProperty(prop)) {
        cloneTarget[prop] = deepClone(target[prop], map);
      }
    }
    return cloneTarget;
  } else {
    return target;
  }
}

export function getObjectDataType(data: any) {
  const temp = Object.prototype.toString.call(data);
  const type = temp?.match(/\b\w+\b/g) || [];
  return type.length < 2 ? "Undefined" : type[1];
}

export function isObjectChanged(source: any, comparison: any): any {
  const iterable = (data: any) =>
    ["Object", "Array"].includes(getObjectDataType(data));
  if (getObjectDataType(source) !== getObjectDataType(comparison)) {
    return true;
  }
  const sourceKeys = Object.keys(source);
  const comparisonKeys = Object.keys({ ...source, ...comparison });
  if (sourceKeys.length !== comparisonKeys.length) {
    return true;
  }
  return comparisonKeys.some((key: any) => {
    if (iterable(source[key])) {
      return isObjectChanged(source[key], comparison[key]);
    } else {
      return source[key] !== comparison[key];
    }
  });
}

export const uploadFileSize = (input: any) => {
  let Sys = {
    ie: false,
    firefox: false,
    Chrome: false,
  };
  let filesize = 0;
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf("MSIE") > 0 || userAgent.indexOf("rv:11.0") > 0) {
    Sys.ie = true;
  }
  if (userAgent.indexOf("Firefox") > 0) {
    Sys.firefox = true;
  }
  if (userAgent.indexOf("Chrome") > 0) {
    Sys.Chrome = true;
  }

  if (Sys.firefox || Sys.Chrome) {
    filesize = input.files[0].size;
  } else if (Sys.ie) {
    //@ts-ignore
    const fileobject = new ActiveXObject("Scripting.FileSystemObject");
    const file = fileobject.GetFile(input.value);
    filesize = file.Size;
  }
  return filesize / (1024 * 1024);
};

export function dateSortComparator(a: any, b: any): any {
  return Date.parse(a ?? 0) - Date.parse(b ?? 0);
}

export function operatorName(name: any) {
  switch (name) {
    case "contains":
      return "Contains";
    case "equals":
      return "Equals";
    case "startsWith":
      return "Starts With";
    case "endsWith":
      return "Ends With";
    case "isEmpty":
      return "is Empty";
    case "isNotEmpty":
      return "is Not Empty";
    default:
      return "";
  }
}

export function handleAPICommonError(err: any) {
  if (
    err?.response?.status === 401 ||
    err?.response?.data?.message === "unauthorized"
  ) {
    return;
  }
}

export const getAllIds = (tree: any, result: any) => {
  if (!Array.isArray(tree)) return [];
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    result.push(node.id);
    if (Array.isArray(node.children)) {
      getAllIds(node.children, result);
    }
  }
  return result;
};

export const canParseToJson = (str: any) => {
  if (typeof str == "string") {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
};

export function dependencyTypeName(type: any) {
  switch (type) {
    case 0:
      return "User";
    case 1:
      return "User Group";
    case 2:
      return "Role";
    case 3:
      return "ACL";
    case 4:
      return "RTQ";
    case 5:
      return "Question";
    case 6:
      return "Workflow";
    default:
      return "";
  }
}

export function changeProductPageTitle(value: string) {
  switch (value) {
    case "Product Information":
      return "Product Information";
    case "Active Ingredient/Substance":
      return "Active Ingredient/Substance";
    case "Trade Name":
      return "Trade Name";
    default:
      return "Trade Name";
  }
}

export function changeRTQPageTitle(value: number) {
  switch (value) {
    case 0:
      return "basicInformation";
    case 1:
      return "questionResponseDetails";
    case 2:
      return "products";
    case 3:
      return "submissions";
    case 4:
      return "categories";
    case 5:
      return "documents";
    case 6:
      return "workflow";
    default:
      return "basicInformation";
  }
}

export function getModuleName(path: string) {
  // @ts-ignore
  for (let [module, paths] of MENU_MODULE_NAME_MAP.entries()) {
    if (path && paths.includes(path)) {
      return module;
    }
  }
  return null; // If no match is found
}

export function getURLDomain() {
  const domain = process.env.REACT_APP_STG_DOMAIN || "";
  const splitByDomain = window.location.hostname.split(domain);
  const splitByDot = splitByDomain[0]?.split(".");
  const domainName = splitByDot[1] ? `${splitByDot[1]}.${domain}` : `${domain}`;

  return domainName;
}

export function firstLetterCapitalize(str: string) {
  if (!str) return "";
  const modifiedString = str.replace(/\b\w/g, function (match) {
    return match.toUpperCase();
  });
  return modifiedString;
}

export const menuToRoute = (str: string = "") => {
  const customRules: any = {
    "Route of Admin": "/route",
  };

  if (customRules[str]) {
    return customRules[str];
  }
  const words = str.split(" ");
  if (words.length > 3) {
    return `/${words[0].toLowerCase()}`;
  }

  const lowerCasedWords = words.map((word) => word.toLowerCase());

  if (lowerCasedWords[lowerCasedWords.length - 1].endsWith("s")) {
    return `/${lowerCasedWords[lowerCasedWords.length - 1].slice(0, -1)}`;
  }

  return `/${lowerCasedWords.join("-")}`;
};

export const transferToAlias = (name: string) => {
  const array = name.match(/\b[A-Z](?:[a-z]*|[A-Z]*(?=[a-z]))\b/g);

  if (!array) return "";
  const kebabCase = array?.map((word) => word.toLowerCase()).join("-");

  return kebabCase;
};

export const toCamelCase = (str: string | undefined = "") => {
  const customRules: any = {
    "Co-Morbidity": "comorbidity",
    "Active Ingredient/Substance": "activeIngredientSubstance",
    "Shelf-Life": "shelfLife",
    "Ing. Other Representation": "representations",
    "Ing. Other Representation Quantity": "representationQuantities",
  };

  if (customRules[str]) {
    return customRules[str];
  }
  const words = str.toLowerCase().split(" ");
  const camelCased = words.map((word, index) =>
    index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1),
  );
  return camelCased.join("");
};

export const isMode = (path: string) => {
  if (path.includes("/edit/")) {
    return "edit";
  } else if (path.includes("/view/")) {
    return "view";
  } else if (path.includes("/add")) {
    return "add";
  } else {
    return "";
  }
};

export const removeChildWithId = (parent: any, idToRemove: string) => {
  return {
    ...parent,
    children: parent.children.filter((child: any) => child.name !== idToRemove),
  };
};

export const actionAlwaysPinnedRight = (originArr?: string[]) => {
  if (Array.isArray(originArr)) {
    const pinnedRightLen = originArr.length;
    if (originArr[pinnedRightLen - 1] !== "action") {
      const tempPinnedRight = originArr.filter((i) => i !== "action");
      tempPinnedRight.push("action");
      return tempPinnedRight;
    }
  }
  return originArr;
};

export const handleSelectedIdentifiers = (
  filterList: any,
  identifierList = [] as any[],
  allSelected?: Record<string, boolean>,
) => {
  let afterFilterList = {} as any;
  for (let key in filterList) {
    if (!identifierList.includes(key)) {
      if (Array.isArray(filterList[key])) {
        if (filterList[key].length > 0) {
          afterFilterList[key] = allSelected?.[key] ? ["all"] : filterList[key];
        }
      } else {
        afterFilterList[key] = allSelected?.[key] ? ["all"] : [filterList[key]];
      }
    }
  }
  return afterFilterList;
};

interface singleIdentifiersMeta {
  module: string;
  section: string;
  menu: string;
}

const transElementToStr = (element: any) => Array.isArray(element) ? '' : element;

export const handleSelectedIdentifiersMeta = (
  originalMeta: Record<string, any>,
  originalIdentifierMap: Record<string, any>,
) => {
  // const pickKeys = Object.keys(originalMeta);
  let resultObj: Record<string, singleIdentifiersMeta[]> = {};
  for (const key in originalIdentifierMap) {
    if (!Object.hasOwn(originalMeta, key)) {
      resultObj[`${key}::`] = [];
      continue;
    }
    const element = originalMeta[key];
    const field = element?.field ?? "";
    if (field && element.module && element.group && element.menu) {
      resultObj[`${key}::${field}`] = [
        {
          module: transElementToStr(element.module),
          section: transElementToStr(element.group),
          menu: transElementToStr(element.menu),
        },
      ];
    } else {
      resultObj[`${key}::${field}`] = [];
    }
  }
  return resultObj;
};

export const addSpace = (str: string) => {
  if (str) {
    return str.split(",").join(", ");
  } else {
    return "";
  }
};

export const sortFn = (a: any, b: any) => {
  return a.order - b.order;
};

export const isLinkField = (
  sinlgeChangeField: Record<string, any>,
  settingsJson: Record<string, any>[],
) => {
  const curChangeTarget = sinlgeChangeField;
  const changeFieldSetting = settingsJson?.find(
    (i) => i.field === curChangeTarget.field,
  );
  const curLinkFieldSetting = changeFieldSetting?.formRules?.linkField;

  return (
    Array.isArray(curLinkFieldSetting) &&
    curLinkFieldSetting?.length > 0 &&
    isEqual(changeFieldSetting?.linkFieldValue, curChangeTarget.value)
  );
};

// export const needCheckDependency = (
//   currentSelectMenu?: Record<string, any>,
// ) => {
//   return !!(
//     currentSelectMenu &&
//     [
//       "Route of Admin",
//       "Protocols",
//       "Pharmaceutical Product",
//       "Compositions",
//       "Ingredients",
//       "Ing. Other Representation",
//       "Ing. Other Representation Quantity",
//       "Components",
//       "Manufactured Item",
//       "Packages",
//       "Shelf-Life",
//       "Organisations",
//       "Business Operations",
//       "Therapeutic Details",
//       "Contraindications",
//     ].indexOf(currentSelectMenu?.name) > -1
//   );
// };

export const handlePromiseError = (error: any) => {
  const curStatus = error?.response?.status;
  const curMsg = error?.response?.data?.message;
  if (curStatus === 401 || curMsg === "unauthorized") {
    return;
  }
  if (curStatus !== 400 && curStatus !== 500) {
    SnackbarUtils.error(curMsg);
  }
};

export const filterFormData = (
  formData?: Record<string, any>,
  extraFields?: string[],
): Record<string, any> => {
  if (!formData) return {};

  const excludeFields = new Set(
    (extraFields || []).map((field) => field.toLowerCase()),
  );

  return Object.keys(formData).reduce((filteredData, key) => {
    if (!excludeFields.has(key.toLowerCase())) {
      filteredData[key] = formData[key];
    }
    if (includeFields.includes(key.toLowerCase())) {
      filteredData[key] = formData[key];
    }
    return filteredData;
  }, {} as Record<string, any>);
};

/** True when on add/edit/view (or metadata variants) under a side menu, not the first-level menu page. */
export function isMenuRecordSubPage(
  pathname: string,
  routeRecordId?: string | null,
): boolean {
  if (routeRecordId) {
    return true;
  }
  if (/\/add\/?$/.test(pathname)) {
    return true;
  }
  if (/\/addmetadata\//.test(pathname)) {
    return true;
  }
  if (/\/(edit|view)\/[^/]+/.test(pathname)) {
    return true;
  }
  if (/\/(edit|view)metadata\//.test(pathname)) {
    return true;
  }
  return false;
}

export function shouldShowMenuTitleTags(
  pathname: string,
  routeRecordId?: string | null,
): boolean {
  return !isMenuRecordSubPage(pathname, routeRecordId);
}